import {GET_USER_FEEDBACK, GET_USER_FEEDBACK_SUCCESS, GET_USER_FEEDBACK_FAILURE } from '../constants';

const initialState = {
    feeback: {},
    fetchingFeedback: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_FEEDBACK:
            return {
                ...state,
                fetchingFeedback: true
            };
        case GET_USER_FEEDBACK_SUCCESS:
            return {
                ...state,
                userFeedback: action.userFeedback,
                fetchingFeedback: false
            };
        case GET_USER_FEEDBACK_FAILURE:
            return {
                ...state,
                error: action.error,
                fetchingFeedback: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/userFeedback.js